import { render, staticRenderFns } from "./WidgetHeader.vue?vue&type=template&id=d0fff59c"
import script from "./WidgetHeader.vue?vue&type=script&lang=js"
export * from "./WidgetHeader.vue?vue&type=script&lang=js"
import style0 from "./WidgetHeader.vue?vue&type=style&index=0&id=d0fff59c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports